import * as React from "react";
import { PaginatedEntityTable, QueryHelper } from "components/common";
import { getRepositoryTypeLabel } from "data-tiering/repository-management/types";
import RepositoryActions from "./RepositoryActions";
import StatusCell from "./cells/StatusCell";
import { DEFAULT_LAYOUT } from "./constants";
import fetchPaginatedRepositories, { keyFn } from "./hooks/fetchPaginatedRepositories";
const columnRenderers = {
  attributes: {
    type: {
      renderCell: (type) => getRepositoryTypeLabel(type),
      staticWidth: 220
    },
    status: {
      renderCell: (_status, repository) => /* @__PURE__ */ React.createElement(StatusCell, { repository }),
      staticWidth: 180
    },
    credential_user: {
      renderCell: (credentialUser) => credentialUser != null ? credentialUser : /* @__PURE__ */ React.createElement("i", null, "None")
    }
  }
};
const entityActions = (repository) => /* @__PURE__ */ React.createElement(RepositoryActions, { repository });
const RepositoriesTable = ({ refetchInterval, onDataLoaded }) => /* @__PURE__ */ React.createElement(
  PaginatedEntityTable,
  {
    humanName: "warm tier repositories",
    fetchEntities: fetchPaginatedRepositories,
    keyFn,
    entityActions,
    tableLayout: DEFAULT_LAYOUT,
    columnRenderers,
    entityAttributesAreCamelCase: false,
    fetchOptions: refetchInterval === false ? void 0 : { refetchInterval },
    onDataLoaded,
    searchPlaceholder: "Search for repositories",
    queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "repository" })
  }
);
export default RepositoriesTable;
